import type { FC } from 'react';
import React, { useContext } from 'react';

import { RicosViewerContext } from './../../ricos-context';
import type { ComponentData, NodeViewRendererProps } from './../../ricos-types';

import { FILE_UPLOAD_TYPE } from '../types';
import { FileViewer } from './file-viewer';

const File: FC<NodeViewRendererProps> = ({ node, nodeIndex, NodeViewContainer }) => {
  const { config, helpers } = useContext(RicosViewerContext);
  return (
    <NodeViewContainer key={node.id} node={node} nodeIndex={nodeIndex}>
      <FileViewer
        nodeId={node.id}
        componentData={node.fileData as ComponentData}
        settings={config[FILE_UPLOAD_TYPE]}
        helpers={helpers}
      />
    </NodeViewContainer>
  );
};

export default File;
